import { render } from "./InterestPlaces.vue?vue&type=template&id=696733f3&scoped=true"
import script from "./InterestPlaces.vue?vue&type=script&lang=js"
export * from "./InterestPlaces.vue?vue&type=script&lang=js"

import "./InterestPlaces.vue?vue&type=style&index=0&id=696733f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696733f3"]])

export default __exports__